import * as React from "react";
import type { SVGProps } from "react";
const SvgPersonMain = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={49}
    height={53}
    fill="none"
    viewBox="0 0 49 53" {...props}
  >
    <g filter="url(#Person-Main_svg__a)">
      <path
        fill="#23F6E7"
        fillRule="evenodd"
        d="M17.236 12.274a3.103 3.103 0 0 1-6.204 0 3.103 3.103 0 0 1 6.203 0m.186 11.393h.302c.907 0 1.645-.74 1.645-1.646v-1.645a4.39 4.39 0 0 0-4.385-4.383h-1.399A4.39 4.39 0 0 0 9.2 20.376v1.645c0 .906.737 1.646 1.645 1.646z"
        clipRule="evenodd"
      />
    </g>
    <defs>
      <filter
        id="Person-Main_svg__a"
        width={47.969}
        height={52.295}
        x={0.3}
        y={0.272}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dx={10} dy={10} />
        <feGaussianBlur stdDeviation={9.45} />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix values="0 0 0 0 0.462745 0 0 0 0 0.556863 0 0 0 0 0.690196 0 0 0 0.2 0" />
        <feBlend
          in2="BackgroundImageFix"
          result="effect1_dropShadow_2257_4324"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect1_dropShadow_2257_4324"
          result="shape"
        />
      </filter>
    </defs>
  </svg>
);
export default SvgPersonMain;
